export default "__VITE_ASSET__CuBCiNh4__"